module.exports = __webpack_public_path__ + "static/media/ic_categories_gadget.810727f9.svg";